import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M21 4H15C14.4313 4.00197 13.8696 4.12518 13.3522 4.36142C12.8349 4.59767 12.3739 4.9415 12 5.37C11.6261 4.9415 11.1651 4.59767 10.6478 4.36142C10.1304 4.12518 9.5687 4.00197 9 4H3C2.73478 4 2.48043 4.10536 2.29289 4.29289C2.10536 4.48043 2 4.73478 2 5V18C2 18.2652 2.10536 18.5196 2.29289 18.7071C2.48043 18.8946 2.73478 19 3 19H8.59C8.85234 19.0011 9.10374 19.1053 9.29 19.29L9.71 19.71C9.89626 19.8947 10.1477 19.9989 10.41 20H13.59C13.8523 19.9989 14.1037 19.8947 14.29 19.71L14.71 19.29C14.8963 19.1053 15.1477 19.0011 15.41 19H21C21.2652 19 21.5196 18.8946 21.7071 18.7071C21.8946 18.5196 22 18.2652 22 18V5C22 4.73478 21.8946 4.48043 21.7071 4.29289C21.5196 4.10536 21.2652 4 21 4V4ZM11 16.54C10.3923 16.1875 9.70252 16.0012 9 16H4V6H9C9.53043 6 10.0391 6.21071 10.4142 6.58579C10.7893 6.96086 11 7.46957 11 8V16.54ZM20 16H15C14.2975 16.0012 13.6077 16.1875 13 16.54V8C13 7.46957 13.2107 6.96086 13.5858 6.58579C13.9609 6.21071 14.4696 6 15 6H20V16Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgLibraryOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgLibraryOutline;
